document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('site-nav--open');
      nav.style.display = nav.classList.contains('site-nav--open') ? 'flex' : '';
    });
  }
});
